/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_o0 as o0,
  rec_s0 as s0,
} from "../../runtime/index.jsx";
export function Componente_p0_112_48(e) {
  let t = (0, ReactCompiler.c)(5),
    { p: n } = e,
    r = `whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] ${s0(n) ? `border-(--error) text-(--error)` : `border-(--border) text-(--text)`}`,
    i;
  t[0] === n.vence
    ? (i = t[1])
    : ((i = o0(n.vence)), (t[0] = n.vence), (t[1] = i));
  let a;
  return (
    t[2] !== r || t[3] !== i
      ? ((a = <span className={r} children={i} />),
        (t[2] = r),
        (t[3] = i),
        (t[4] = a))
      : (a = t[4]),
    a
  );
}
